import { Link, useLocation } from "react-router-dom"
import { useTheme } from "@material-ui/core/styles"
import { useTranslation } from "react-i18next"

import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"

import { useAppSelector } from "common/hooks"
import { Role } from "common/types/user.type"

const AdminNavigation = () => {
    const { t } = useTranslation()
    const items = [
        {
            label: t("view.admin.companies"),
            to: "/admin/companies",
            minRole: Role.Superadmin
        },
        {
            label: t("view.admin.users"),
            to: "/admin/users2",
            minRole: Role.Admin
        },
        {
            label: t("view.admin.catalogs"),
            to: "/admin/catalogs",
            minRole: Role.Moderator
        }
        /*
        {
          label: t('view.admin.iconSets'),
          to: '/admin/icon-sets',
          minRole: Role.Moderator,
        },
        {
          label: t('view.admin.icons'),
          to: '/admin/icons',
          minRole: Role.Moderator,
        },
        */
    ]

    const theme = useTheme()
    const { pathname } = useLocation()
    const { user: currentUser } = useAppSelector(state => state.auth)

    let tabs = items
    if (currentUser) {
        const currentUserRole = Role[currentUser.role]
        tabs = tabs.filter(({ minRole }) => minRole <= currentUserRole)
    }

    return (
        <Tabs centered value={pathname}>
            {tabs.map(({ to, label }, index) => (
                <Tab
                    key={index}
                    value={to}
                    label={label}
                    component={Link}
                    to={to}
                    style={{
                        color: to === pathname ? theme.palette.primary.main : undefined
                    }}
                />
            ))}
        </Tabs>
    )
}

export default AdminNavigation
